import { RejectedAdsKeywordsColumn } from './rejected-ads-keywords-column';

export class RejectedKeywordsColumn extends RejectedAdsKeywordsColumn {
  constructor({
    i18n, scope, filterState, isOptimizationScoreOn,
  }) {
    super({
      i18n,
      scope,
      filterState,
      isKeyword: true,
      isOptimizationScoreOn,
    });
  }
}
